import { Record } from 'immutable'

// Record
export const PaymentInfosRecord = Record(
  {
    id: '',
    last4: null,
    credit: 0,
    plan: null,
    coupon: null,
    subscription: null,
    cardExpMonth: null,
    cardExpYear: null,
    cardBrand: null,
    vatId: null,
    billingEmail: '',
    addressName: null,
    addressLine1: null,
    addressLine2: null,
    addressCity: null,
    addressPostalCode: null,
    addressState: null,
    addressCountry: null,
  },
  'PaymentInfos'
)
